<script setup lang="ts">
import {LoyaltyCardMembership} from "@/loyalty-card/interfaces/hds/LoyaltyCard";
import Credit from '@/customer/components/customer-loyalty-membership/CustomerLoyaltyMembershipCredit.vue';
import Product from '@/customer/components/customer-loyalty-membership/CustomerLoyaltyMembershipProduct.vue';
import Discount from '@/customer/components/customer-loyalty-membership/CustomerLoyaltyMembershipDiscount.vue';
import LoyaltyCardVisual from "@/loyalty-card-membership/components/loyalty-card-visual/LoyaltyCardVisual.vue";
import LoyaltyCardProgress from "@/loyalty-card-membership/components/loyalty-card-progress/LoyaltyCardProgress.vue";

defineEmits(['refresh']);
defineProps<{
    membership: LoyaltyCardMembership;
    customerId: number;
    /** Open the offer dialog right away (counter pop-up shortcut). */
    openReward?: boolean;
}>();
</script>

<template>
  <div class="w-full flex flex-col gap-4">
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div class="flex flex-wrap items-center gap-5">
        <LoyaltyCardVisual :membership="membership" />
        <div>
          <p class="text-primary text-xl font-bold">
            {{ membership.loyalty_card.name }}
          </p>
          <p class="text-slate-500">
            {{ membership.loyalty_card.organization.name }}
          </p>
        </div>
      </div>
      <div class="flex-shrink-0 flex flex-wrap gap-2">
        <Discount
          v-if="membership.loyalty_card.point_rewards_count"
          :membership="membership"
          @attributed="$emit('refresh')"
        />

        <Product
          v-if="membership.loyalty_card.product_rewards_count"
          :membership="membership"
          :customer-id="customerId"
          :auto-open="openReward"
          @attributed="$emit('refresh')"
        />

        <Credit
          :membership="membership"
          :customer-id="customerId"
          @credited="$emit('refresh')"
        />
      </div>
    </div>

    <LoyaltyCardProgress :membership="membership" />
  </div>
</template>
